__turbopack_context__.v({
  "copy": "PlpIntro-module__-I-XsG__copy",
  "expanded": "PlpIntro-module__-I-XsG__expanded",
  "makeModelIntro": "PlpIntro-module__-I-XsG__makeModelIntro",
  "viewMore": "PlpIntro-module__-I-XsG__viewMore",
});
